import { format } from 'date-fns';
import { parse } from 'date-fns';
import { MappedData } from '../types';

const getMonthName = (record: string) => {
  const date = parse(record, 'yyyy-MM-dd HH:mm:ss', new Date());
  const monthName = format(date, 'MMMM yyyy').toLowerCase();
  return monthName;
};
export const categorizePurchasesByMonth = (purchaseData: any) => {
  const mappedData: MappedData = {};

  for (let index = 0; index < purchaseData.length; index++) {
    const element = purchaseData[index];
    const month = getMonthName(element.created_at);

    if (!mappedData[month]) {
      mappedData[month] = [];
    }

    mappedData[month].push(element);
  }
  return mappedData;
};
